import { ArrowsClockwise } from '@phosphor-icons/react'
import { countDecimalsAndAdd0, decimalToHours } from 'Utils/helperFunctions'
import CurrencyInput from 'react-currency-input-field'
import TableBudgetsItem from './TableBudgetsItem'

const TableBudgets = ({ budgetSettings, budgets, onAddBudget }) => {
  const getPercent = ({ spent, budget }) => {
    if (spent === 0) return 0

    if (budget === 0) return 100

    return countDecimalsAndAdd0({ number: (spent * 100) / (budget || 0) })
  }

  const getRest = ({ spent, budget }) => {
    return countDecimalsAndAdd0({ number: budget - spent })
  }

  const showHours = ({ budget }) => {
    const hours = decimalToHours({ time: budget }).split(':')

    return `${hours[0]}h ${hours[1]}m`
  }

  return (
    <>
    <p>Update your current budget by filling the new budget field.</p>
    <div className="table-responsive">
      <table className="table align-middle">
        <thead>
          <tr>
            <th scope="col">Task</th>
            <th scope="col" className='text-no-wrap'>Logged hours</th>
            <th className="px-4" scope="col">Budget</th>
            {onAddBudget && <th className='text-no-wrap'>New Budget ({ budgetSettings?.type === 'Fee per task type' ? '$' : 'hours' })</th>}
          </tr>
        </thead>
        <tbody>
          { budgets.map((budget, i) => (<TableBudgetsItem budget={budget} budgetSettings={budgetSettings} key={i} onAddBudget={onAddBudget}/>)) }
        </tbody>
      </table>
    </div>
    </>
  )
}

export default TableBudgets
